import { render, staticRenderFns } from "./templateEdit.vue?vue&type=template&id=0b49c7bf&scoped=true&"
import script from "./templateEdit.vue?vue&type=script&lang=js&"
export * from "./templateEdit.vue?vue&type=script&lang=js&"
import style0 from "./templateEdit.vue?vue&type=style&index=0&id=0b49c7bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b49c7bf",
  null
  
)

export default component.exports